(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoot-request"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('[data-shoot-request]');
    if (!root) return;
    const form = root.querySelector('form');
    if (!form || form.querySelector('[autofocus].shoot-request__success')) return;

    const slots = (root.dataset.slots || '10:00,11:30,13:00,14:30,16:00,17:30')
      .split(',')
      .map((slot) => slot.trim())
      .filter(Boolean);
    const dateInput = root.querySelector('[data-date-input]');
    const timeInput = root.querySelector('[data-time-input]');
    const grid = root.querySelector('[data-cal-grid]');
    const label = root.querySelector('[data-cal-label]');
    const times = root.querySelector('[data-times]');
    const error = root.querySelector('[data-form-error]');
    const details = root.querySelector('[data-site-details]');
    const weekdays = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    let cursor = new Date();
    cursor.setDate(1);
    cursor.setHours(0, 0, 0, 0);
    let selectedDate = '';
    let selectedTime = '';

    const toDay = () => {
      const now = new Date();
      now.setHours(0, 0, 0, 0);
      return now;
    };

    const iso = (date) => {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const showError = (message) => {
      error.textContent = message;
      error.hidden = !message;
    };

    const renderTimes = () => {
      times.innerHTML = '';
      if (!selectedDate) {
        times.innerHTML = `<p class="shoot-request__hint">${root.dataset.selectDate}</p>`;
        return;
      }
      slots.forEach((slot) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'shoot-request__time' + (slot === selectedTime ? ' is-selected' : '');
        button.textContent = slot;
        button.addEventListener('click', () => {
          selectedTime = slot;
          timeInput.value = slot;
          renderTimes();
        });
        times.append(button);
      });
    };

    const renderCalendar = () => {
      const year = cursor.getFullYear();
      const month = cursor.getMonth();
      label.textContent = cursor.toLocaleString(undefined, { month: 'long', year: 'numeric' });
      grid.innerHTML = '';
      weekdays.forEach((day) => {
        const el = document.createElement('span');
        el.className = 'shoot-request__dow';
        el.textContent = day;
        grid.append(el);
      });
      const start = new Date(year, month, 1).getDay();
      const offset = start === 0 ? 6 : start - 1;
      const days = new Date(year, month + 1, 0).getDate();
      for (let i = 0; i < offset; i += 1) {
        grid.append(document.createElement('span'));
      }
      const min = toDay();
      for (let day = 1; day <= days; day += 1) {
        const date = new Date(year, month, day);
        const value = iso(date);
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'shoot-request__day' + (value === selectedDate ? ' is-selected' : '');
        button.textContent = String(day);
        button.disabled = date < min;
        button.addEventListener('click', () => {
          selectedDate = value;
          dateInput.value = value;
          selectedTime = '';
          timeInput.value = '';
          renderCalendar();
          renderTimes();
        });
        grid.append(button);
      }
    };

    root.querySelector('[data-cal-prev]').addEventListener('click', () => {
      cursor.setMonth(cursor.getMonth() - 1);
      renderCalendar();
    });
    root.querySelector('[data-cal-next]').addEventListener('click', () => {
      cursor.setMonth(cursor.getMonth() + 1);
      renderCalendar();
    });
    root.querySelectorAll('[data-site-option]').forEach((input) => {
      input.addEventListener('change', () => {
        details.required = input.value === 'Own location' && input.checked;
      });
    });

    form.addEventListener('submit', (event) => {
      if (!dateInput.value || !timeInput.value) {
        event.preventDefault();
        showError(root.dataset.errorSlot);
        return;
      }
      const site = form.querySelector('[data-site-option]:checked');
      if (!site) {
        event.preventDefault();
        showError(root.dataset.errorSite);
        return;
      }
      const brief = form.querySelector('#Shoot-brief');
      const territory = form.querySelector('[name="contact[territory]"]:checked');
      const refsUrl = form.querySelector('[data-refs-url]');
      const fieldValue = (selector) => {
        const field = form.querySelector(selector);
        return field && field.value ? field.value.trim() : '';
      };
      brief.value = [
        brief.value.trim(),
        '',
        `COMPANY: ${fieldValue('#Shoot-company')}`,
        `PROJECT TYPE: ${fieldValue('#Shoot-project-type')}`,
        `LAUNCH: ${fieldValue('#Shoot-launch')}`,
        `TERRITORY: ${territory ? territory.value : ''}`,
        `SITE: ${site.value}`,
        `SLOT: ${dateInput.value} ${timeInput.value}`,
        `USAGE: ${fieldValue('#Shoot-usage')}`,
        `BUDGET: ${fieldValue('#Shoot-budget')}`,
        `PRODUCTION: ${fieldValue('#Shoot-production')}`,
        `REFERENCE LINK: ${refsUrl && refsUrl.value ? refsUrl.value : 'none'}`
      ].join('\n');
    });

    renderCalendar();
    renderTimes();
  })();

  } catch(e) { console.error(e); }
})();
})();
